import Glide from "@glidejs/glide";

document
  .querySelectorAll('.glide-staff')
  .forEach((slider) => {
    if (slider) {
      const config = {
        perView: 5,
        focusAt: 0,
        gap:15,
        rewind: false,
        bound: true,
        type: 'slider',
        autoheight: true,
        breakpoints: {
          480: {
            perView: 2
          }
        }
      };

      const CustomLength = function(Glide, Components, Events) {
        return {
          mount () {
            Events.emit('slider.length', Components)
          }
        }
      }
      
      let glide = new Glide(slider, config)
    
      glide.on('slider.length', (components) => {
        let control = components.Controls
        let length = components.Sizes.length

        if(length <= 5 && document.body.clientWidth > 480){
          glide.settings.dragDistance = false;
          glide.disable()
          control.items[0]?.classList.add('hidden')
        } else if (length <= 2 && document.body.clientWidth < 480) {
          control.items[0]?.classList.add('hidden')

          glide.disable()
        }
      })

      glide.on('resize', () => {
        glide.update({})
      })

      if(document.getElementById('tabs')){
        const div = document.getElementById('tabs')        
        const resizeObserver = new ResizeObserver(() => {          
          glide.update({})
        });
        resizeObserver.observe(div);
      }

      glide.mount({ CustomLength })
      
      }
  } ) 